import { Injectable } from '@angular/core';
import { IResultNavigationDetails, IResultPageState } from '@fpx/common/models';
import { IHttpErrorPayload, IHttpSuccessPayload } from '@fpx/core/models';

@Injectable({
  providedIn: 'root',
})
export class ResultPageService {
  constructor() {}

  private title: string = 'Done';
  private alertType!: 'Success' | 'Warning' | 'Failed';
  private navigationDtls!: IResultNavigationDetails[];
  private resultPayload!: Partial<IHttpSuccessPayload<any> | IHttpErrorPayload>;
  private serviceCode: string = '';
  private subTitle1: string = '';
  private subTitle2: string = '';
  private subTitle3: string = '';

  setTitle(title: string) {
    this.title = title;
  }

  setService(serviceCode: string) {
    this.serviceCode = serviceCode;
  }

  setResultPayload<T>(
    resultPayload: IHttpSuccessPayload<T> | IHttpErrorPayload
  ) {
    this.resultPayload = resultPayload;
  }

  setSuccess() {
    this.alertType = 'Success';
    this.title = 'Transaction has been completed successfully';
    this.subTitle1 = 'Transaction Reference - @@ref_no@@';
  }

  setFailure() {
    this.alertType = 'Failed';
    this.title = 'Transaction has been Failed';
  }

  get resultPageData(): IResultPageState {
    return {
      title: this.title,
      alertType: this.alertType,
      navigationDtls: this.navigationDtls,
      resultPayload: this.resultPayload,
      serviceCode: this.serviceCode,
      subTitle1 : this.subTitle1
    };
  }

  resetResultPageData() {
    this.title = '';
    this.alertType = 'Success';
    this.navigationDtls = [];
    this.resultPayload = {};
    this.serviceCode = '';
    this.subTitle1 = '';
    this.subTitle2 = '';
    this.subTitle3 = '';
  }
}
